import { render, staticRenderFns } from "./noSend.vue?vue&type=template&id=b7ad94a4&scoped=true"
import script from "./noSend.vue?vue&type=script&lang=js"
export * from "./noSend.vue?vue&type=script&lang=js"
import style0 from "./noSend.vue?vue&type=style&index=0&id=b7ad94a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad94a4",
  null
  
)

export default component.exports